<template lang="pug">
  spreadsheet(:opts='user_opts')
</template>

<script>
export default {
  data() {
    return {
      registeration: {
        show: false,
        url: '',
        title: '',
      },
      user_opts: {
        tableName: 'users',
        displayName: '用户',
        columns: [
          {
            label: 'account',
          },
          {
            label: '姓名',
          },
          {
            label: '类型',
            type: 'select',
            options: ['前端', '后端', '全能', '其他'],
          },
          {
            label: '部门',
            type: 'select',
            options: ['猎头业务部', '咨询部', '运营部', '技术研发部'],
          },
          {
            label: '角色',
            type: 'select',
            options: ['管理员', '行政', '财务', '团队长', '团队长2', '普通用户'],
          },
          {
            label: '职级',
            type: 'select',
            options: ['R', 'AC', 'C', 'SC-1', 'SC-2', 'AD', 'D', 'ED-1', 'ED-2', '合伙人', '管理合伙人'],
          },
          {
            label: '悬赏系统角色',
            type: 'select',
            options: ['管理员', '普通用户'],
          },
          {
            label: '所属组',
            type: 'spreadsheet',
            spreadsheet: {
              opts: {
                tableName: 'users',
                columns: [
                  {
                    label: 'account',
                  },
                ],
                editable: false,
                actionbar: false,
              },
            },
          },
          {
            label: '队员',
            type: 'spreadsheet',
            spreadsheet: {
              opts: {
                tableName: 'users',
                columns: [
                  {
                    label: 'account',
                  },
                ],
                editable: false,
                actionbar: false,
              },
            },
          },
          {
            label: 'SL权限',
            type: 'spreadsheet',
            spreadsheet: {
              opts: {
                tableName: 'categories',
                columns: [
                  {
                    label: '名称',
                  },
                ],
                editable: false,
                actionbar: false,
              },
            },
          },
          {
            label: '培训权限',
            type: 'select',
            options: [1, 2, 3, 4, 5],
          },
          {
            label: '新版模板权限',
            type: 'select',
            options: ['有', '无'],
          },
          {
            label: '新版培训权限',
            type: 'select',
            options: ['有', '无'],
          },
          {
            label: '系统使用教学权限',
            type: 'select',
            options: ['有', '无'],
          },
        ],
        defaultItem: {
          permissions: {
            所有人: '读写',
          },
        },
        maxItem: 1000,
        showPagination: true,
        expandable: true,
        creatable: true,
        trackable: true,
        actionbar: false,
        update: (data, label, value) =>
          app
            .service('users')
            .patch(data._id, {
              [`${label}`]: value,
            })
            .then(() => {
              if (data.account === app.user.account) {
                return (app.user[`${label}`] = value)
              }
            }),
      },
    }
  },
  created() {
    return this.checkRole()
  },
  methods: {
    checkRole() {
      const flag = app.user && app.user.角色 && app.user.角色.includes('管理员')
      if (!flag) router.push('/')
      // let ref
      // if (!(((ref = app.user) != null ? ref['角色'] : void 0) === '管理员')) {
      //   return router.push('/')
      // }
    },
  },
}
</script>
